import { Component } from '@angular/core';

@Component({
  selector: 'webapp-compat-navigation-secondary-help',
  template: `
    <app-navigation-secondary-help></app-navigation-secondary-help>
    <router-outlet></router-outlet>
  `,
})
export class CompatNavigationSecondaryHelpComponent {}



// WEBPACK FOOTER //
// /mnt/jenkins-slave-workspace/workspace/gaf-build-i18n-webapp-compat/LANG/de/webapp/src/compat/compat-navigation-secondary-help.component.ts